import styled from 'styled-components';
import { ThemeColours } from '../../../../../../styles/ThemeColours';
import { FONT_STACK, FontWeight, FontSize } from '../../../../../../styles/constants';
import { HeImgix } from '../../../../../images/HeImgix';

export const SuggestionIcon = styled.div`
  color: ${ThemeColours.mono600};
  height: 20px;
  margin: 10px;
  width: 20px;
`;

export const PracticeIcon = styled.div`
  color: ${ThemeColours.mono600};
  height: 40px;
  margin: 10px;
  width: 40px;
`;

export const Text = styled.span`
  ${FONT_STACK}
`;

export const SuggestionPrimary = styled(Text)`
  color: ${ThemeColours.black};
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.SEMI_BOLD};
`;

export const SuggestionPrimaryLight = styled(Text)`
  color: ${ThemeColours.mono600};
  font-size: ${FontSize.REGULAR};
`;

export const SuggestionSecondary = styled(Text)`
  color: ${ThemeColours.mono600};
  font-size: ${FontSize.SMALL};
`;

export const SpecialtyIcon = styled(HeImgix)`
  width: 20px;
`;
